import AppDashboard from '../AppDashboard';
import DataExportScreen from '../../components/admin/DataExportScreen';

const DataExportPage= props => {
  return (
    <AppDashboard>
      <DataExportScreen />
    </AppDashboard>
  );
};

export default DataExportPage;